<template>
  <vue-slider
    :disabled="disabled()"
    :value="value"
    @change="update"
    :max="max"
    :min="min"
    :lazy="true"
    :interval="interval"
    width="100%"
    height="8px"
    :process="false"
  >
    <template v-slot:dot="{  focus }">
      <div :class="['custom-dot', { focus }]"></div>
    </template>
  </vue-slider>
</template>
<script>
import VueSlider from "vue-slider-component";
import { mapState } from "vuex";

export default {
  props: ["min", "max", "interval", "update", "target", "value"],
  components: {
    VueSlider
  },
  methods: {
    disabled() {
      if (typeof this.state.ERRORS === "undefined") return false;
      if (Object.keys(this.state.ERRORS).length === 0) return false;
      return true;
    }
  },
  computed: {
    ...mapState({
      state: state => state.base
    })
  }
};
</script>
<style>
@import url("../../../node_modules/vue-slider-component/theme/antd.css");
@import url("../../../node_modules/vue-slider-component/dist-css/vue-slider-component.css");
</style>

<style scope lang="scss">
.vue-slider {
  color: #e3e3e3;
}
.custom-dot {
  &:hover {
    cursor: pointer;
  }
  position: relative;
  top: -8px;
  height: 30px !important;
  width: 30px !important;
  background-color: #acd14d;
  border-radius: 50%;
  background-image: url("../../../public/slider.svg") !important;
  background-position: center !important;

  background-repeat: no-repeat !important;
  background-size: 16px 16px !important;
}
</style>